/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-12 18:13:57
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-20 18:58:36
 */
import {AnyAction} from "redux";
import {ADGroupState} from "@/redux/interface";
import produce from "immer";

const ADGroupInfo: ADGroupState = {
	adGroupInfo: {},
	store: {}
};

// auth reducer
const ADGROUP = (state: ADGroupState = ADGroupInfo, action: AnyAction) =>
	produce(state, draftState => {
		switch (action.type) {
			case "SET_AD_GROUP_INFO":
				draftState.adGroupInfo = {...action.adgroup};
				break;
			case "SET_CURRENT_STORE":
				draftState.store = {...action.store};
				break;
			default:
				return draftState;
		}
	});

export default ADGROUP;
